import axios from 'axios'
import costuto from '@/apis/costuto.js'
import helpers from '@/store/helpers.js'

const state = {
}

const getters = {
}

const actions = {
  create: ({ dispatch }, payload) => {
    let data = helpers.dataFormat('session', payload)
    return new Promise((resolve, reject) => {
      costuto().post('sessions', data)
        .then(resp => {
          const user = JSON.parse(resp.data.user).data
          const token = resp.data.token
          localStorage.setItem('token', token)
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
          dispatch('setup', { user, token }, { root: true })
          resolve(user.attributes.cosplayer_name)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  destroy: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit('logout', null, { root: true })
      localStorage.removeItem('token')
      resolve()
    })
  },
  update: ({ dispatch, commit, rootState }) => {
    if (rootState.token) {
      costuto().put('sessions/renew')
        .then(resp => {
          const user = JSON.parse(resp.data.user).data
          const token = resp.data.token
          localStorage.setItem('token', token)
          dispatch('setup', { user, token }, { root: true })
        })
        .catch(_ => {
          dispatch('destroy')
        })
    } else {
      // If there is not token in state, clean everything
      dispatch('destroy')
    }
  }
}

const mutations = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
